import React, { Component } from 'react';
import {
    NavBar,
    BreadCumb,
    TimeOut,
    PartnerCreateModal,
    PdfViewer,
    NewCustomerModal,
    ConfigurationPointsCardModal,
    PointEquivalencePointsCardModal,
    PrintToDocumentsModal,
    AreYouAgreeModal,
    PaymentInvoiceCreditPoinstCardModal,
    LimitPoinstCardModal,
} from '../../components';
import { Datos_Empresa, development } from "../../libs/utils/Const";
import { DISPATCH_ID, SERVICE_RESPONSE, CURRENCY } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import config from '../../config';
import '../../css/tablesPOS.css';
import { ApiClient } from "../../libs/apiClient";
import $ from "jquery";
import moment from "moment";
import {
    NewOrderSales,
    NewOrder,
    NewItemPayment,
    PointsCardModel,
    NewCustomer,
    Definitions,
} from "../../components/NewOrder";
import packageJson from '../../../package.json';
import { CSVLink } from 'react-csv';
let apiClient = ApiClient.getInstance();

global.appVersion = packageJson.version;
const currentVersion = global.appVersion;

const EMAIL_FORMAT_REGEX = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales

    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },

    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class PointsCardView extends Component {
    csvLink = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            folio: '',
            cliente: '',
            checkboxDataTables: (new Map()),
            partners: [],
            pageTotal: 0,
            total: 0,
            ModelCollect: new NewOrderSales(),
            newOrderModel: [],

            idWorkShift: "",
            sendMailModel: {
                to: '',
                subject: '',
                docEntry: ''
            },
            docsToPrint: [],
            showPDFViewer: false,
            EnableEditButton: false,

            printhide: true,
            auxCacheEntry: null,



            dataInvoice: [],


            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            PointsCardModel: new PointsCardModel(),
            dataCustomer: [],
            showNewCustomerModal: false,
            showConfigurationPointsCard: false,
            showAreYouAgreeModal: false,
            showAreYouAgreeModal_Point_Value: false,
            showAreYouAgreeModal_Update: false,
            accountStatus: [],
            actionCustomer: 0,
            showAreYouAgreeModal_Reset: false,
            showConfigPointEquivalence: false,
            showPaymentInvoiceCredit: false,
            showAreYouAgreeModal_InvoiceCredit: false,
            showLimitPoints: false,
            showAreYouAgreeModal_LastDate: false,
            walletPermissions: [],
            // showAreYouAgreeModal_GenGenReport: false,
            dataCsv: [],
        }
    }

    componentDidMount = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        this._handelBack();

        enableSpinner(true);
        // SI SE REQUIEREN LISTAR TODOS LOS USUARIOS CON MONEDERO HAY QUE DESCOMENTAR LA LINEA DE ABAJO
        // this.GetAllCustomersPoints();
        this.GetAllConfiguration();
        await this.setWalletUserPermissions(user);
        enableSpinner(false);

        await this.setState({
            LimitLinesBO: user.Branch.LimitLines || null,
            CounterRol: user.U_FMB_CounterRol || null,
        });
    }
    setWalletUserPermissions = async (user) => {

        if (!user.USERID) return;
        const { enableSpinner } = this.props;
        enableSpinner(true);
        const walletPermissionsResponse = await apiClient.getWalletUserPermissions(user.USERID);

        enableSpinner(false);
        if (walletPermissionsResponse.status == SERVICE_RESPONSE.SUCCESS) {
            const walletPermissions = await this.setWalletPermissions(walletPermissionsResponse.data.UserPermissions || [], walletPermissionsResponse.data.WalletModules || [])

            await this.setState({
                walletPermissions
            })
        }
    }

    setWalletPermissions = (userPermissions, WalletModules) => {
        for (let index = 0; index < WalletModules.length; index++) {
            const walletModule = WalletModules[index];
            const findModule = userPermissions.find(userPermission => userPermission.WalletPermission === walletModule.idWalletPermissions)

            if (findModule) {
                walletModule.Active = findModule.Active
            } else {
                walletModule.Active = 'N'
            }
        }
        return WalletModules;

    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 1; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            if (tableReg.rows[i].classList.contains("noSearch")) {
                continue;
            }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length === 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR = tableReg.rows[tableReg.rows.length - 1];
        const td = lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText === "") {
            lastTR.classList.add("hide");
        } else if (total) {
            td.innerHTML = "Se ha encontrado " + total + " coincidencia" + ((total > 1) ? "s" : "");
        } else {
            lastTR.classList.add("red");
            td.innerHTML = "No se han encontrado coincidencias";
        }
    }

    CargarDatos = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { folio, cliente, PointsCardModel } = this.state;

        if (cliente === '') {
            showAlert({ type: 'warning', message: 'Escribe el código de un cliente' });
            return;
        }
        const datos = {
            folio,
            cliente,
        }

        enableSpinner(true);
        const Invoices = await apiClient.getOneCustomersPoints(cliente);
        enableSpinner(false);

        if (Invoices.status === SERVICE_RESPONSE.SUCCESS) {

            if (!Array.isArray(Invoices.data)) {
                showAlert({ type: 'info', message: Invoices.message });
                return;
            }

            if (Invoices.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                this.setState({
                    dataInvoice: [],
                    checkboxDataTables: (new Map()),
                });
                return;
            }
            showAlert({ type: 'info', message: 'El usuario seleccionado sí existe en el monedero electrónico.' });

            // await this.GetDownPaymentsByPartner(cliente);
            this.setState({
                dataCustomer: Invoices.data,
                dataInvoiceCopy: Invoices.data,
                checkboxDataTables: (new Map()),
            });

            if (Invoices.data.length === 0) {
                this.setState({
                    dataCustomer: [],
                    checkboxDataTables: (new Map()),
                });
            }
            return;

        } else {
            const dataClient = await apiClient.getPartnerPoints('C', cliente);

            if (dataClient.status === SERVICE_RESPONSE.SUCCESS) {

                if (!Array.isArray(dataClient.data)) {
                    showAlert({ type: 'info', message: dataClient.message });
                    return;
                }

                if (dataClient.data.length === 0) {
                    showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                    this.setState({
                        dataInvoice: [],
                        checkboxDataTables: (new Map()),
                    });
                    return;
                }

                let partner = dataClient.data[0];

                PointsCardModel.Customer.CardCode = partner.CardCode;
                PointsCardModel.Customer.CardName = partner.CardName;
                PointsCardModel.Customer.U_FMB_Handel_Email = partner.U_FMB_Handel_Email || '';
                PointsCardModel.Customer.U_FMB_Cellular = partner.U_FMB_Cellular || '';
                PointsCardModel.Customer.U_FMB_Handel_Pass = partner.U_FMB_Handel_Pass || '';
                await this.RefreshModel(PointsCardModel);
                await this.setState({
                    showNewCustomerModal: !this.state.showNewCustomerModal,
                    actionCustomer: partner.pointsCard ? 2 : 1,
                });
                $('#partnerCreate').modal('hide');
                $('#newCustomer').modal({ backdrop: 'static', keyboard: false }, 'show');
            }
        }
    };

    ChangeFolio = event => {
        let valor = event.nativeEvent.target.value;
        this.setState({
            folio: valor
        });
    };

    ChangeCliente = event => {
        let valor = event.nativeEvent.target.value;
        this.setState({
            cliente: valor,
            dataCustomer: [],
        });
    };

    MapFind(map, callback) {
        for (const [key, value] of map) {
            if (callback(value, key, map)) {
                return value;
            }
        }
        return undefined;
    }

    toggleDocumentSelected = async (id) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { dataCustomer, auxCacheEntry } = this.state

        if (auxCacheEntry !== null) {
            const actualEntry = dataCustomer[id];
            if (auxCacheEntry.U_SO1_02METODOPAGO !== actualEntry.U_SO1_02METODOPAGO) {
                showAlert({ type: 'info', message: `SOLO PUEDES SELECCIONAR FACTURAS DE UN TIPO, LA ANTERIOR SELECCIONADA ES DE TIPO: ${auxCacheEntry.U_SO1_02METODOPAGO} Y LA QUE QUERÍA SELECCIONAR ES DE TIPO ${actualEntry.U_SO1_02METODOPAGO}`, timeOut: 6500 });
                return;
            }
        }

        await this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id));
            return { checkboxDataTables };
        });

        const result = this.MapFind(this.state.checkboxDataTables, (value, key, map) => {
            return value === true; // Custom condition to find 'value2'
        });

        if (result === undefined) {
            await this.setState({
                auxCacheEntry: null
            })
        } else {
            await this.setState({
                auxCacheEntry: dataCustomer[id]
            })

        }



    };

    toggleDocumentSelectedAll = (action) => {
        const { dataCustomer } = this.state;
        let newCheckbox = (new Map());

        for (let index = 0; index < dataCustomer.length; index++) {
            const register = dataCustomer[index];

            if (register.statusBorrador !== 'W') {
                newCheckbox.set(index, action)
            }
        }

        this.setState({
            checkboxDataTables: newCheckbox
        });
    };

    openPartner = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let getPartnerResponse = await apiClient.getPartnerPoints('C', null);
        enableSpinner(false);

        if (getPartnerResponse.status === 0) {
            if (!Array.isArray(getPartnerResponse.data.results)) {
                showAlert({ type: 'info', message: getPartnerResponse.message });
                return;
            }
            if (getPartnerResponse.data.results.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }
        this.setState({
            partners: getPartnerResponse.data.results ? getPartnerResponse.data.results : getPartnerResponse.data,
            pageTotal: getPartnerResponse.data.totalPage || 1,
            dataCustomer: [],
        });
        $('#partnerCreate').modal('show');

    };

    SelectPartner = async action => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { partners, PointsCardModel } = this.state;
        let partner = partners[action.index];

        // if (partner.pointsCard) {
        const infoCliente = await apiClient.getOneCustomersPoints(partner.CardCode);

        enableSpinner(false);

        if (infoCliente.status === SERVICE_RESPONSE.SUCCESS) {

            if (!Array.isArray(infoCliente.data)) {
                showAlert({ type: 'info', message: infoCliente.message });
                return;
            }

            if (infoCliente.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                this.setState({
                    dataCustomer: [],
                    checkboxDataTables: (new Map()),
                });
                return;
            }
            showAlert({ type: 'info', message: 'El usuario seleccionado sí existe en el monedero electrónico.' });
            $('#partnerCreate').modal('hide');
            this.setState({
                dataCustomer: infoCliente.data,
                checkboxDataTables: (new Map()),
            });
            // }
        } else {
            PointsCardModel.Customer.CardCode = partner.CardCode;
            PointsCardModel.Customer.CardName = partner.CardName;
            PointsCardModel.Customer.U_FMB_Handel_Email = partner.U_FMB_Handel_Email || '';
            PointsCardModel.Customer.U_FMB_Cellular = partner.U_FMB_Cellular || '';
            PointsCardModel.Customer.U_FMB_Handel_Pass = partner.U_FMB_Handel_Pass || '';
            // PointsCardModel.Customer.ItemsPayments = '';
            // PointsCardModel.Customer.total = total;
            await this.RefreshModel(PointsCardModel);
            await this.setState({
                showNewCustomerModal: !this.state.showNewCustomerModal,
                actionCustomer: partner.pointsCard ? 2 : 1,
            });
            $('#partnerCreate').modal('hide');
            $('#newCustomer').modal({ backdrop: 'static', keyboard: false }, 'show');
        }
    }

    RefreshPartner = async (partner, totalPage) => {
        this.setState({
            partners: partner,
            pageTotal: totalPage
        });
    };

    Abonar = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ModelCollect, idWorkShift } = this.state;

        ModelCollect.totalRecibido = (Number(ModelCollect.CashSum) + Number(ModelCollect.CreditSum) + Number(ModelCollect.CheckSum) + Number(ModelCollect.TrsfrSum));

        if (Number(ModelCollect.TotalRecibido) < Number(ModelCollect.totalPago)) {
            showAlert({ type: 'error', message: 'El total del documento no corresponde al total de dinero recibido' });
            return;
        }

        ModelCollect.idSession = idWorkShift;
        ModelCollect.CardCode = ModelCollect.CardCode || ModelCollect.ItemsPayments[0].CardCode;
        ModelCollect.U_FMB_AUX_CARDNAME = ModelCollect.U_FMB_AUX_CARDNAME || ModelCollect.ItemsPayments[0].U_FMB_AUX_CARDNAME;
        ModelCollect.OriginDoc = 'Cobranza-Abonar';
        const data = {
            destino: "ORCT",
            docSubType: "--",
            reserveInvoice: "tNO",
            model: ModelCollect,
            Time: moment().format(),
            ClientVersion: currentVersion
        };

        enableSpinner(true);
        let createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status || createDocumentResponse.status !== 1) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + createDocumentResponse.message, timeOut: 5000 });
            return;
        }

        $('#collectionModal').modal('hide');
        let payment = createDocumentResponse.data.serviceLayeResponse || {};
        let folio = createDocumentResponse.data.createdFolio || '';
        let paymentInvoices = payment.PaymentInvoices || [];
        let timbraResponse = payment.timbraResponse || null;
        let document = createDocumentResponse.data;
        showAlert({
            type: "success",
            message: "Pago exitoso con No. : " + document.createdFolio,
            timeOut: 5000,
        });

        await this.CargarDatos();
        ModelCollect.SerieCode = '';
        ModelCollect.CashAcct = '';
        ModelCollect.CashAcctFormatCode = '';
        ModelCollect.CashSum = '';
        ModelCollect.ItemsPayments = [];
        ModelCollect.PaymentsCreditCards = [];
        ModelCollect.CreditSum = '';
        ModelCollect.PaymentsToSale = [];
        setTimeout(() => {
            this.setState({
                ModelCollect,
            });
        }, 100);
    }

    SearchPayment = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { folio, cliente } = this.state;

        if (folio === '') {
            showAlert({ type: 'warning', message: 'Escribe el número de folio' });
            return;
        }
        let datos = {
            folio,
            cliente,
        }
        enableSpinner(true);
        let IncomingPayments = await apiClient.getIncomingPayments(datos);
        enableSpinner(false);
        if (IncomingPayments.status === SERVICE_RESPONSE.SUCCESS) {

            let newOrderModel = this.createNewOrderDetails(IncomingPayments);

            this.setState({
                newOrderModel: newOrderModel,
            });

            $('#paymentModal').modal({ backdrop: 'static', keyboard: false }, 'show');
            return;
        } else {
            this.setState({
            });
        }
        showAlert({ type: 'error', message: IncomingPayments.message });
    }

    createNewOrderDetails = (detailsResponse) => {
        let newOrderModel = new NewOrder();

        let header = detailsResponse.data.header;
        let items = detailsResponse.data.items || [];
        let checks = detailsResponse.data.paymentChecks;

        newOrderModel.OriginDocumentCreate = 'payment';
        newOrderModel.userFields = [];
        newOrderModel.ObjType = header.ObjType;
        newOrderModel.DocType = header.DocType;
        newOrderModel.DocumentType = "F";
        newOrderModel.WddStatus = header.WddStatus;
        newOrderModel.DocEntry = header.DocEntry || "";
        newOrderModel.DocEntryRel = header.DocEntryRel || "";
        newOrderModel.CardCode = header.CardCode;
        newOrderModel.Balance = header.Balance || 0;
        newOrderModel.UserID = 0;
        newOrderModel.DocStatus = header.DocStatus;
        newOrderModel.CardName = header.CardName;
        newOrderModel.NextFolio = header.DocNum;
        newOrderModel.DocNum = header.DocNum;
        newOrderModel.StatusDocument = '';
        newOrderModel.NumAtCard = header.NumAtCard;
        newOrderModel.SerieName = header.SeriesName;
        newOrderModel.SerieCode = header.Series;
        newOrderModel.ExtraDays = header.metodoPago;
        newOrderModel.SerieArray = [];
        newOrderModel.DocDate = moment(header.DocDate).format('YYYY-MM-DD');
        newOrderModel.DocDueDate = moment(header.DocDueDate).format('YYYY-MM-DD');
        newOrderModel.TaxDate = moment(header.TaxDate).format('YYYY-MM-DD');
        newOrderModel.ReqDate = moment(header.ReqDate).format('YYYY-MM-DD');
        newOrderModel.ReqType = header.ReqType;
        newOrderModel.Requester = header.Requester;
        newOrderModel.ReqName = header.ReqName;
        newOrderModel.Branch = header.Branch;
        newOrderModel.BranchName = header.BranchName;
        newOrderModel.Department = header.Department;
        newOrderModel.DepartmentName = header.DepartmentName;
        newOrderModel.Email = header.Email;
        newOrderModel.Notify = header.Notify;
        newOrderModel.SlpCode = header.SlpCode;
        newOrderModel.SlpName = header.SlpName;
        newOrderModel.CntctCode = header.CntctCode;
        newOrderModel.CntctName = header.CntntName;
        newOrderModel.OwnerCode = header.OwnerCode || "";
        newOrderModel.OwnerName = header.OwnerName || "";
        newOrderModel.Comments = header.Comments || "";
        newOrderModel.Status = '';
        newOrderModel.StepCode = '';
        newOrderModel.WtmName = '';
        newOrderModel.Subtotal = 0;
        newOrderModel.DiscountPercent = parseFloat(header.DiscPrcnt).toFixed(2);
        newOrderModel.Discount = 0;
        newOrderModel.Taxes = 0;
        newOrderModel.Total = 0;
        newOrderModel.Items = [];

        newOrderModel.GroupNum = header.GroupNum;
        newOrderModel.GroupName = header.condicionesPago;
        newOrderModel.GroupCode = header.GroupCode;
        newOrderModel.PymCode = header.PeyMethod;
        newOrderModel.PymName = header.payDescription;
        newOrderModel.indexRowDetails = '';

        //Direccion de entrega para documentos generales
        newOrderModel.Address2 = header.Address2;
        newOrderModel.ShipToCode = header.ShipToCode;
        // definido desde el usuario
        newOrderModel.TaxeDefaultPartner = header.TaxCode || '';
        newOrderModel.TaxeRateDefaultPartner = header.TaxCodeRate || '';
        newOrderModel.OcrCode2DefaultPartner = header.OcrCode2 || '';
        newOrderModel.AcctCodeDefaultPartner = header.AcctCodeItem || '';
        newOrderModel.CogsAcctDefaultPartner = header.CogsAcctItem || '';
        newOrderModel.AcctCodeNameDefaultPartner = header.AcctCodeItemName || '';
        newOrderModel.CogsAcctNameDefaultPartner = header.CogsAcctItemName || '';

        //Trasnfers
        newOrderModel.Address = header.Address;
        newOrderModel.Filler = header.Filler;
        newOrderModel.FillerName = "";
        newOrderModel.PickRmrk = header.PickRmrk || '';
        newOrderModel.ToWhsCode = header.ToWhsCode || '';
        newOrderModel.ToWhsCodeName = "";
        newOrderModel.JrnlMemo = header.JrnlMemo;
        newOrderModel.GroupNumTraslado = header.GroupNum;
        newOrderModel.GroupNumTrasladoName = header.ListName;
        //Pagos
        newOrderModel.TransId = header.TransId || "";
        newOrderModel.CounterRef = header.CounterRef || "";
        newOrderModel.NoDocSum = parseFloat(header.NoDocSum).toFixed(2) || 0;
        newOrderModel.BpAct = header.BpAct || "";
        newOrderModel.BpActFormatCode = header.BpActFormatCode || "";
        newOrderModel.BpActName = "";
        newOrderModel.PayNoDoc = header.PayNoDoc === 'Y' ? true : false;
        newOrderModel.CashSum = header.DocCurr === 'SOL' ? header.CashSum : header.CashSumFC;
        newOrderModel.CreditSum = header.DocCurr === 'SOL' ? header.CreditSum : header.CredSumFC;
        newOrderModel.CheckSum = header.DocCurr === 'SOL' ? header.CheckSum : header.CheckSumFC;
        newOrderModel.TrsfrSum = header.DocCurr === 'SOL' ? header.TrsfrSum : header.TrsfrSumFC;
        // trasferencias
        newOrderModel.TrsfrAcct = header.TrsfrAcct;
        newOrderModel.TrsfrAcctName = header.TrsfrAcctName;
        newOrderModel.TrsfrDate = moment(header.TrsfrDate).add(1, 'd').format('YYYY-MM-DD');
        newOrderModel.TrsfrRef = header.TrsfrRef;
        newOrderModel.TrsfrAcctFormatCode = header.TrsfrAcctFormatCode;
        // cheques
        newOrderModel.CheckAcct = header.CheckAcct;
        newOrderModel.CheckList = checks;
        newOrderModel.CheckAcctFormatCode = header.CheckAcctFormatCode;
        //cash
        newOrderModel.CashAcct = header.CashAcct;
        newOrderModel.CashAcctFormatCode = header.CashAcctFormatCode;

        //Lista de precios C100 /
        newOrderModel.PriceListNum = header.ListNum || "";
        //CreditLine
        newOrderModel.CreditLine = header.CreditLine || 0;
        newOrderModel.transactionId = header.TransId || '';
        newOrderModel.PaidToDate = header.PaidToDate || 0;
        newOrderModel.BackOrder = header.BackOrder || '';
        newOrderModel.PartDelivr = header.PartDelivr || '';
        newOrderModel.folio = header.folio;


        //Tipo cambiario
        newOrderModel.DocCur = header.DocCurr;
        newOrderModel.ChangeRate = header.DocRate || 1;
        let newService = [];
        let newItemsPayment = [];
        let lastLineNum = items.length;

        for (let index = 0; index < items.length; index++) {
            const item = items[index];

            let itemModelPayment = new NewItemPayment();

            if ((lastLineNum - 1) === index) {
                newOrderModel.LastLineNumItems = item.LineNum;
            }

            itemModelPayment.DocEntry = item.DocEntry;
            itemModelPayment.DocNum = item.DocNum;
            itemModelPayment.docType = item.ObjType;
            itemModelPayment.DocSubType = item.DocSubType;
            itemModelPayment.RefDate = moment(item.TaxDate).add(1, 'd').format('YYYY-MM-DD');
            itemModelPayment.daysLast = 0;
            itemModelPayment.total = item.DocCur === 'SOL' ? item.DocTotal : item.DocTotalFC;
            itemModelPayment.pastDueBalance = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidToDate) : (item.DocTotalFC - item.PaidFC);
            itemModelPayment.totalPago = item.DocCur === 'SOL' ? parseFloat(item.totalPago ? item.totalPago : item.PaidSum).toFixed(4) : item.totalPagoFC;
            itemModelPayment.DocCur = item.DocCur;
            itemModelPayment.totalOutgoing = item.DocCur === 'SOL' ? item.SumApplied : item.totalPagoFC;
            itemModelPayment.saldoVencido = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidSum) : (item.DocTotalFC - item.PaidFC);
            itemModelPayment.OcrCode = item.OcrCode;
            itemModelPayment.OcrName = "";
            itemModelPayment.OcrCode2 = item.OcrCode2;
            itemModelPayment.OcrName2 = "";
            itemModelPayment.OcrCode3 = item.OcrCode3;
            itemModelPayment.OcrName3 = "";
            itemModelPayment.OcrCode4 = item.OcrCode4;
            itemModelPayment.OcrName4 = "";
            itemModelPayment.OcrCode5 = item.OcrCode5;
            itemModelPayment.OcrName5 = "";

            newItemsPayment.push(itemModelPayment);
        }

        newOrderModel.service = newService;
        newOrderModel.ItemsPayments = newItemsPayment;

        if (newOrderModel.WddStatus === "P") {
            newOrderModel.isDocumentWithAuthorization = true; // servicio 2 donde no actualiza los items solo el documento
        }

        //PAGOS
        newOrderModel.totalDocumento = 0;
        newOrderModel.totalPago = 0;
        newOrderModel.CheckSum = 0;

        newOrderModel.ItemsPayments.map(item => {
            newOrderModel.totalDocumento += Number(item.pastDueBalance); //item.total
            newOrderModel.totalPago += Number(item.totalPago);
        });

        newOrderModel.CheckList.map(item => {
            newOrderModel.CheckSum += Number(item.CheckSum);
        });

        if (newOrderModel.PayNoDoc) {
            newOrderModel.totalDocumento = newOrderModel.NoDocSum;
        }


        newOrderModel.totalRecibido = Number(newOrderModel.CashSum) + Number(newOrderModel.CreditSum) + Number(newOrderModel.CheckSum) + Number(newOrderModel.TrsfrSum);

        if (newOrderModel.DocCur != newOrderModel.DocCurDocumentsPayment) {
            let localCurrency = CURRENCY;
            let rate = 1;
            if (localCurrency == newOrderModel.DocCur) {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCurDocumentsPayment == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });

                newOrderModel.totalPago = Number((newOrderModel.totalPago * rate).toFixed(2));
            } else {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCur == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });
                newOrderModel.totalPago = Number((newOrderModel.totalPago / rate).toFixed(2));
            }
        }

        newOrderModel.totalPago = Number((newOrderModel.totalPago).toFixed(2));
        newOrderModel.totalRestante = newOrderModel.totalPago - newOrderModel.totalRecibido;

        // Datos para cancelación
        newOrderModel.IdSession = header.idSession ?? null;

        return newOrderModel;

    };

    //#region --------PAGOS--------

    CreateDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const {
            ModelCollect,
            idWorkShift,
            requireInvoice,
            billAddresses,
            deliveryAddresses,
            setDeliveryIndex,
            setBillIndex,
            disableRecover
        } = this.state;
        if (!ModelCollect.Items.length) {
            showAlert({ type: "warning", message: "Documento sin artículos", timeOut: 2000 });
            return;
        }

        for (let i = 0; i < ModelCollect.Items.length; i++) {
            const DocItem = ModelCollect.Items[i];
            if (DocItem.Quantity === '' || DocItem.Quantity === 0) {
                ModelCollect.Items[i].Quantity = 1;
            }
        }

        this.FillDataFromPartner();
        let table = this.selectTable(requireInvoice ? 'invoice' : ModelCollect.ObjType);
        ModelCollect.idSession = idWorkShift;
        ModelCollect.OriginDoc = 'Cobranza-CreateDocument';
        await this.IsPayedByDownPayment();
        let isUniversal = await this.CheckIfItsUniversalPartner();

        let data = {
            destino: table.name,
            docSubType: table.docSubType,
            reserveInvoice: table.reserveInvoice,
            model: ModelCollect,
            isDraft: ModelCollect.ObjType === 'deliveries4' ? true : false,
            ItsDeliveryInvoice: (ModelCollect.ObjType === 'deliveries2' && requireInvoice) ? true : false,
            ItsRecoverDoc: disableRecover,
            ItsDeliveryDoc: (ModelCollect.ObjType === 'deliveries2' && isUniversal) ? true : false,
            Time: moment().format(),
            ClientVersion: currentVersion,
        };
        // return
        enableSpinner(true);
        let createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud" + createDocumentResponse.message, timeOut: 5000 });


            return;
        }
        // $("#ticketModal").modal("show");
        let folio = createDocumentResponse.data.createdFolio;
        let document = createDocumentResponse.data.serviceLayeResponse;
        showAlert({ type: "success", message: "Gracias por tu compra: " + folio, timeOut: 5000 });

        ModelCollect.DocNum = document.DocNum;
        ModelCollect.DocTime = document.DocTime;
        ModelCollect.DocEntry = document.DocEntry;
        ModelCollect.folio = folio;
        ModelCollect.NumAtCard = '';
        ModelCollect.RecoverIdSale = '';
        ModelCollect.Comments = '';
        ModelCollect.PaymentsToSale = [];
        if (data.ItsRecoverDoc) {
            ModelCollect.ItsRecoverDoc = 'Y';
        }

        if (ModelCollect.ObjType === 'deliveries4') {
            $("#refSaleModal").modal("show");
            ModelCollect.Items = [];
            ModelCollect.Total = 0;
        } else if (ModelCollect.ObjType === 'orderSales') {
            // this.ShowFormatOrderSaleModal();
            // $("#formatOrderSaleModal").modal("show");
            // do{
            //   if (showFormatOrderSaleModal===true) {
            //     ModelCollect.Items = []; 
            //     ModelCollect.Total = 0;
            //   }
            // }while (showFormatOrderSaleModal===true) 
        }

        await this.setState({
            ModelCollect,
            isCancel: false,
            disableRecover: false,
        });

        if (requireInvoice || ModelCollect.ObjType === 'invoiceReserve') {
            $("#billModal").modal("hide");
            this.ShowCreatedInvoice(createDocumentResponse.data.createdFolio, false);
        } else if (ModelCollect.ObjType === 'deliveries') {
            $("#ticketModal").modal("show");
            this.PrintDocuments(ModelCollect.ItsRecoverDoc === "Y" ? "ComprobantePago" : "NotaCaja", "80", ModelCollect);
        } else if (ModelCollect.ObjType === 'quotations') {
            this.ShowCreatedQuotation(createDocumentResponse.data.createdFolio);
        } else if (ModelCollect.ObjType === 'orderSales') {
            this.ShowCreatedOrder(createDocumentResponse.data.createdFolio);
        } else if (ModelCollect.ObjType === 'deliveries2') {
            this.ShowCreatedDeliveryDoc(createDocumentResponse.data.createdFolio);
        } else if (ModelCollect.ObjType === 'downPayments') {
            this.ShowCreatedDownPayment(createDocumentResponse.data.createdFolio);
        }
    };

    GetDownPaymentsByPartner = async (cardCode) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let data = {
            CardCode: cardCode
        }
        enableSpinner(true);
        let responseApi = await apiClient.getDownPaymentsByPartner(data);
        enableSpinner(false);

        if (responseApi.status === 0) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }

        this.setState({
        })
    };

    CheckIfItsUniversalPartner = async () => {
        const { _user, ModelCollect } = this.state;
        let flag = true;
        if (_user?.Partner !== null && _user?.Partner !== undefined && _user?.Partner !== '') {
            if (ModelCollect.CardCode !== _user?.Partner.CardCode) {
                flag = false;
            } else {
                flag = true;
            }
        }
        await this.setState({ isUniversal: flag })
        return flag
    };

    PrintDocuments = async (type, paperSize, order) => {
        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        let items = [];
        let payments = [];

        for (let index = 0; index < order.Items.length; index++) {
            items[index] = {
                ItemCode: order.Items[index].ItemCode || "",
                ItemName: (order.Items[index].ItemName ? order.Items[index].ItemName : order.Items[index].ItemDescription) || "",
                Price: (order.Items[index].HomePrice ? order.Items[index].HomePrice.toString() : order.Items[index].UnitPrice) || "",
                Quantity: order.Items[index].Quantity.toString() || "",
                UM: order.Items[index].InvntryUom ? order.Items[index].InvntryUom : "" || ""
            }
        }

        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: user.Branch.Address || "",
                RFC: user.Timbra.RFC || "",
                Phone: user.Branch.Phone || "",
                Logo: "",
                Footer: "Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración. * Precios Sujetos a Cambio Sin Previo Aviso. ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.*** Maniobras de descarga a cargo del cliente. Toda cancelación o devolución sólo será efectiva presentando la nota y en un plazo no mayor a 7 días. Si se requiere factura, es en un plazo no mayor a 7 días, y/o en los casos que aplique, antes de cierre de mes.",
                Consecutive: ""
            },
            BusinessPartner: {
                CardCode: user.Partner.CardCode || "",
                CardName: user.Partner.CardName || "",
                RFC: user.Partner.LicTradNum || "",
                Regime: "PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL",
                Phone: user.Partner.Phone1 || "",
                AddressInvoice: "ALBARREAL #112, REAL TOLEDO. C.P.: 42185, PACHUCA, HIDALGO. MX",
                AddressDelivery: "ALBARREAL #112, REAL TOLEDO. C.P.: 42185, PACHUCA, HIDALGO. MX"
            },
            OrderSale: {
                DocNum: order.folio || "",
                DocDate: order.DocDate + " " + order.DocTime || "",
                DocOrigen: "XXXXX",
                Seller: "VENTA DE PISO",
                Cashier: user.USER_CODE || "",
                DocTotal: order.Total || "",
                Subtotal: order.Subtotal || "",
                TaxTotal: order.Taxes || "",
                TaxRate: order.TaxRate || "",
                DocCur: order.DocCur || "",
                Items: items || "",
                Payments: payments || ""
            }
        }
        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        let print = await apiClient.PrintDocuments(data);

    };
    //#endregion --------PAGOS--------

    //#region ########## MAIL FUNCTIONS  #################################################
    OpenSendMailModal = () => {
        $("#pdfSendMailModal").modal("show");
    };

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    };

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state;
        sendMailModel.docEntry = docsToPrint[0].header.DocEntry;

        let data = {
            sendMailModel,
            typeDoc: 'ORCT',
            objType: 24,
            infoDoc: [{
                cardCode: docsToPrint[0].header.CardCode ?? '',
                folio: docsToPrint[0].header.folio ?? '',
                docEntry: docsToPrint[0].header.DocEntry ?? '',
                slpInfo: {
                    slpCode: !!docsToPrint[0].header ? !!docsToPrint[0].header.responseHeader && !!docsToPrint[0].header.responseHeader.SlpCode !== undefined && docsToPrint[0].header.responseHeader.SlpCode : !!docsToPrint[0].docHeader.SlpCode !== undefined && docsToPrint[0].docHeader.SlpCode || '',
                    slpName: !!docsToPrint[0].header ? !!docsToPrint[0].header.responseHeader && !!docsToPrint[0].header.responseHeader.SlpName !== undefined && docsToPrint[0].header.responseHeader.SlpName : !!docsToPrint[0].docHeader.SlpName !== undefined && docsToPrint[0].docHeader.SlpName || '',
                }
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    };
    //#endregion


    //#region ########## NEW #################################################
    GetAllConfiguration = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;
        enableSpinner(true);
        let valorPunto = await apiClient.GetAllConfiguration();
        enableSpinner(false);
        if (valorPunto.status !== 1) {
            showAlert({ type: "error", message: `${valorPunto.message}` });
            return;
        }

        PointsCardModel.Point_Value = valorPunto.data ? Number(valorPunto.data[0].Point_Value || 0).toFixed(2) : 0;
        PointsCardModel.last_reset_date = valorPunto.data ? valorPunto.data[0].last_reset_date : '';
        PointsCardModel.InvoiceCredit = valorPunto.data ? valorPunto.data[0].InvoiceCredit : 'N';
        PointsCardModel.reset = valorPunto.data ? valorPunto.data[0].reset : 0;
        PointsCardModel.periodo = valorPunto.data ? valorPunto.data[0].periodo : '';

        if (PointsCardModel.reset) {
            showAlert({ type: "info", message: `Hoy vencen los puntos del monedero electrónico.`, timeOut: 10000 });
            showAlert({ type: "info", message: `Es necesario actualizar la fecha de la vigencia de puntos.`, timeOut: 10000 });
            this.activeShowAreYouAgree_Reset();
        } else {
            this.closeLimitPointsCardModal();
        }
        this.RefreshModel(PointsCardModel);
    };

    change_Point_Value = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;
        let value = event.nativeEvent.target.value
        if (Number(value) > 10) {
            showAlert({ type: 'warning', message: 'El valor por punto no puede ser mayor a 10 pesos.' });
            return;
        }
        PointsCardModel.Point_Value = Number(value).toFixed(2);
        this.RefreshModel(PointsCardModel);
    };

    // TRAER TODOS LOS CLIENTES CON MONEDERO ELECOTRONICO
    GetAllCustomersPoints = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.getAllCustomersPoints();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        this.setState({ dataCustomer: responseApi.data || [] })
    };

    AddNewCustomer = async (action = null) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { checkboxDataTables, dataCustomer, ModelCollect } = this.state;
        if (action === 1) {
            // let docEntryArray = [];

            // for (let [id, value] of checkboxDataTables.entries()) {
            //     if (value) {
            //         docEntryArray.push(dataCustomer[id]);
            //     }
            // }

            // if (docEntryArray.length === 0) {
            //     showAlert({ type: 'warning', message: "Seleccione un documento" });
            //     return;
            // }
            // let total = 0;
            // for (let index = 0; index < docEntryArray.length; index++) {
            //     const element = docEntryArray[index];
            //     element.totalPago = Number(element.totalPago).toFixed(2);
            //     element.U_Parcialidad = '1'
            //     total += Number(element.PorVencer);
            // }
            // let defaultName = "";
            // let defaultcode = "";
            // let nextNumber = "";


            // ModelCollect.SerieName = defaultName;
            // ModelCollect.SerieCode = defaultcode;
            // ModelCollect.NextFolio = nextNumber;
            // ModelCollect.ItemsPayments = docEntryArray;
            // ModelCollect.total = total;
            // await this.setState({
            //     ModelCollect
            // });
        }

        await this.setState({
            showNewCustomerModal: !this.state.showNewCustomerModal,
        });

        $('#newCustomer').modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    ShowOneCustomer = async (cardCode = null) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;

        enableSpinner(true);
        let responseApi = await apiClient.getOneCustomersPoints(cardCode);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        let detail = responseApi.data[0] || '';

        PointsCardModel.Customer.CardCode = detail.cardCode;
        PointsCardModel.Customer.CardName = detail.CardName;
        PointsCardModel.Customer.U_FMB_Handel_Email = detail.U_FMB_Handel_Email || '';
        PointsCardModel.Customer.U_FMB_Cellular = detail.U_FMB_Cellular || '';
        PointsCardModel.Customer.U_FMB_Handel_Pass = detail.U_FMB_Handel_Pass || '';
        // PointsCardModel.Customer.ItemsPayments = '';
        // PointsCardModel.Customer.total = total;

        await this.RefreshModel(PointsCardModel);
        await this.setState({
            showNewCustomerModal: !this.state.showNewCustomerModal,
            actionCustomer: 2,
        });
        $('#newCustomer').modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    // clearSocio = () => {
    // };

    change_CardName = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;
        let value = event.nativeEvent.target.value
        if (value.length > 100) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida' });
        }
        PointsCardModel.Customer.CardName = value;
        this.RefreshModel(PointsCardModel);
    };

    change_U_FMB_Handel_Email = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;
        let value = event.nativeEvent.target.value;
        if (value.length > 100) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida.' });
        }
        PointsCardModel.Customer.U_FMB_Handel_Email = value;
        this.RefreshModel(PointsCardModel);
    };

    change_U_FMB_Cellular = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;
        let value = event.nativeEvent.target.value;
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Solo se permiten números.' });
            return
        }
        if (value.length > 20) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida.' });
        }
        PointsCardModel.Customer.U_FMB_Cellular = value;
        this.RefreshModel(PointsCardModel);
    };

    change_U_FMB_Handel_Pass = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;
        let value = event.nativeEvent.target.value
        if (value.length > 100) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida' });
        }
        PointsCardModel.Customer.U_FMB_Handel_Pass = value;
        this.RefreshModel(PointsCardModel);
    };

    sendNewCustomer = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;

        if (!PointsCardModel.Customer.U_FMB_Handel_Email) {
            showAlert({ type: "warning", message: "Es necesario registrar un correo electrónico.", timeOut: 5000 });
            return;
        };

        if (!EMAIL_FORMAT_REGEX.test(PointsCardModel.Customer.U_FMB_Handel_Email)) return showAlert({
            type: 'warning',
            message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'
        });

        if (!PointsCardModel.Customer.U_FMB_Cellular) {
            showAlert({ type: "warning", message: "Es necesario registrar un número de teléfono.", timeOut: 5000 });
            return;
        };

        if (PointsCardModel.Customer.U_FMB_Cellular.length < 10) {
            showAlert({ type: "warning", message: "El número de teléfono debe de incluir al menos 10 caracteres.", timeOut: 5000 });
            return;
        };

        enableSpinner(true);
        let data = {
            Customer: PointsCardModel.Customer,
        }
        let response_NewCustomerPointsCard = await apiClient.NewCustomerPointsCard(data);
        if (response_NewCustomerPointsCard.status !== 1) {
            showAlert({ type: "error", message: `${response_NewCustomerPointsCard.message}` });
            enableSpinner(false);
            return;
        }
        showAlert({ type: "success", message: `${response_NewCustomerPointsCard.message}` });
        PointsCardModel.Customer = {};
        $("#newCustomer").modal("hide");
        this.RefreshModel(PointsCardModel);
        enableSpinner(false);
    };

    UpdateCustomer = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;
        // $('#areYouAgreeModal').modal('hide');
        // CERRAR EL MODAL DE CUSTOMER
        $("#newCustomer").modal("hide");
        await this.setState({
            showAreYouAgreeModal_Update: false,
        });
        if (!PointsCardModel.Customer.U_FMB_Handel_Email) {
            showAlert({ type: "warning", message: "Es necesario registrar un correo electrónico.", timeOut: 5000 });
            return;
        };

        if (!EMAIL_FORMAT_REGEX.test(PointsCardModel.Customer.U_FMB_Handel_Email)) return showAlert({
            type: 'warning',
            message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'
        });

        if (!PointsCardModel.Customer.U_FMB_Cellular) {
            showAlert({ type: "warning", message: "Es necesario registrar un número de teléfono.", timeOut: 5000 });
            return;
        };

        if (PointsCardModel.Customer.U_FMB_Cellular.length < 10) {
            showAlert({ type: "warning", message: "El número de teléfono debe de incluir al menos 10 caracteres.", timeOut: 5000 });
            return;
        };

        enableSpinner(true);
        let data = {
            Customer: PointsCardModel.Customer,
        }
        let response_UpdateCustomerPointsCard = await apiClient.UpdateCustomerPointsCard(data);

        if (response_UpdateCustomerPointsCard.status !== 1) {
            showAlert({ type: "error", message: `${response_UpdateCustomerPointsCard.message}` });
            enableSpinner(false);
            return;
        }
        showAlert({ type: "success", message: `${response_UpdateCustomerPointsCard.message}` });
        PointsCardModel.Customer = {};
        // $("#newCustomer").modal("hide");
        this.RefreshModel(PointsCardModel);
        enableSpinner(false);
    };

    ShowConfig = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        const { PointsCardModel } = this.state;
        let definitions = await apiClient.GetDefinitions();

        enableSpinner(false);
        if (definitions.status !== 1) {
            showAlert({ type: "error", message: `${definitions.message}` });
            return;
        }

        PointsCardModel.Definitions = definitions.data || [];
        this.RefreshModel(PointsCardModel);
        // Cargar el valor por punto al abrir el modal de configuración
        await this.GetAllConfiguration();
        await this.setState({
            showConfigurationPointsCard: !this.state.showConfigurationPointsCard,
        });

        $('#configurationPointsCard').modal('show');
    };
    setFunction = (module) => {
        switch (module) {
            case 'CountPoints':
                this.ShowConfigPointEquivalence()
                break;
            case 'Levels':
                this.ShowConfig()
                break;
            case 'PayInvoices':
                this.ShowPaymentInvoiceCredit()
                break;
            case 'PointsValidity':
                this.ShowLimitPoints()
                break;
            case 'GenGenReport':
                this.GenerateGeneralReport()
                break;
            default:
                break;
        }
    }
    ShowConfigPointEquivalence = async () => {
        await this.GetAllConfiguration();
        await this.setState({
            showConfigPointEquivalence: !this.state.showConfigPointEquivalence,
        });

        $('#pointEquivalencePointsCard').modal('show');
    };

    Add_Definitions = async (event, index) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;

        let sendContinue = false;
        let InstanceModel = new Definitions();

        if (PointsCardModel.Definitions.length === 0) {
            PointsCardModel.Definitions.push(InstanceModel);
        } else {
            let contador = PointsCardModel.Definitions.filter(objeto => objeto.isNew).length;

            if (contador >= 1) {
                for (let index = 0; index < PointsCardModel.Definitions.length; index++) {
                    const definition = PointsCardModel.Definitions[index];
                    if (definition.isNew) {

                        if (!definition.name) {
                            sendContinue = true;
                        }
                        if (!definition.MinAmount) {
                            sendContinue = true;
                        }
                        if (!definition.MaxAmount) {
                            sendContinue = true;
                        }
                        if (!definition.PerAmount) {
                            sendContinue = true;
                        }
                        if (!definition.PerSpecial) {
                            sendContinue = true;
                        }
                    }
                }
            }

            if (sendContinue) {
                showAlert({ type: "warning", message: `No has llenado todos los campos necesarios para la nueva definición.` });
                return;
            }
            let ultimaPosicion = PointsCardModel.Definitions[PointsCardModel.Definitions.length - 1];

            let auxLines = PointsCardModel.Definitions.slice();
            let newMinAmount = Number(ultimaPosicion.MaxAmount) + 1
            InstanceModel.MinAmount = Number(newMinAmount).toFixed(2);
            auxLines.push(InstanceModel)
            PointsCardModel.Definitions = auxLines;
        }
        this.RefreshModel(PointsCardModel);
    };

    RefreshModel = async (PointsCardModel) => {
        await this.setState({
            PointsCardModel
        })
    };

    Delete_Definitions = async (index) => {
        const { PointsCardModel } = this.state;
        let auxLines = PointsCardModel.Definitions.slice();
        auxLines.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        PointsCardModel.Definitions = auxLines;
        this.RefreshModel(PointsCardModel);
    };

    change_Name = (event, index) => {
        const { PointsCardModel } = this.state;
        PointsCardModel.Definitions[index].name = event.nativeEvent.target.value;
        this.RefreshModel(PointsCardModel);
    };

    change_MinAmount = (event, index) => {
        const { PointsCardModel } = this.state;
        PointsCardModel.Definitions[index].MinAmount = event.nativeEvent.target.value;
        this.RefreshModel(PointsCardModel);
    };

    change_MaxAmount = (event, index) => {
        const { PointsCardModel } = this.state;
        PointsCardModel.Definitions[index].MaxAmount = event.nativeEvent.target.value;
        this.RefreshModel(PointsCardModel);
    };

    change_PerAmount = (event, index) => {
        const { PointsCardModel } = this.state;
        PointsCardModel.Definitions[index].PerAmount = event.nativeEvent.target.value;
        this.RefreshModel(PointsCardModel);
    };

    change_Points = (event, index) => {
        const { PointsCardModel } = this.state;
        PointsCardModel.Definitions[index].Points = event.nativeEvent.target.value;
        this.RefreshModel(PointsCardModel);
    };

    change_RegularProfit = (event, index) => {
        const { PointsCardModel } = this.state;
        PointsCardModel.Definitions[index].RegularProfit = event.nativeEvent.target.value;
        this.RefreshModel(PointsCardModel);
    };

    change_SpecialProfit = (event, index) => {
        const { PointsCardModel } = this.state;
        PointsCardModel.Definitions[index].SpecialProfit = event.nativeEvent.target.value;
        this.RefreshModel(PointsCardModel);
    };

    change_PerSpecial = (event, index) => {
        const { PointsCardModel } = this.state;
        PointsCardModel.Definitions[index].PerSpecial = event.nativeEvent.target.value;
        this.RefreshModel(PointsCardModel);
    };

    activeShowAreYouAgreeModal = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;
        let isExistNew = PointsCardModel.Definitions.find(definition => definition.isNew === true);

        if (!isExistNew) {
            showAlert({ type: "warning", message: `No has creado una nueva definición.` });
            return;
        }

        let sendContinue = false;
        for (let index = 0; index < PointsCardModel.Definitions.length; index++) {
            const definition = PointsCardModel.Definitions[index];

            if (definition.isNew) {

                if (!definition.name) {
                    sendContinue = true;
                }
                if (!definition.MinAmount) {
                    sendContinue = true;
                }
                if (!definition.MaxAmount) {
                    sendContinue = true;
                }
                if (!definition.PerAmount) {
                    sendContinue = true;
                }
                if (!definition.PerSpecial) {
                    sendContinue = true;
                }
            }
        }
        if (sendContinue) {
            showAlert({ type: "warning", message: `No has llenado todos los campos necesarios para la nueva definición.` });
            return;
        }

        await this.setState({
            showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
        });
        $('#areYouAgreeModal').modal('show');
    };

    activeShowAreYouAgree_Update = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;

        if (!PointsCardModel.Customer.U_FMB_Handel_Email) {
            showAlert({ type: "warning", message: "Es necesario registrar un correo electrónico.", timeOut: 5000 });
            return;
        };

        if (!EMAIL_FORMAT_REGEX.test(PointsCardModel.Customer.U_FMB_Handel_Email)) return showAlert({
            type: 'warning',
            message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'
        });

        if (!PointsCardModel.Customer.U_FMB_Cellular) {
            showAlert({ type: "warning", message: "Es necesario registrar un número de teléfono.", timeOut: 5000 });
            return;
        };

        if (PointsCardModel.Customer.U_FMB_Cellular.length < 10) {
            showAlert({ type: "warning", message: "El número de teléfono debe de incluir al menos 10 caracteres.", timeOut: 5000 });
            return;
        };
        await this.setState({
            showAreYouAgreeModal_Update: !this.state.showAreYouAgreeModal_Update,
        });
        $('#areYouAgreeModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    desactiveShowAreYouAgree_Update = async () => {
        $('#newCustomer').modal('hide').on('hidden.bs.modal', function () {
            $('.modal-backdrop').removeClass('fade show').remove();
        });

        await this.setState({
            showAreYouAgreeModal_Update: false,
        });
    };

    Add_newDefinition = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;

        const data = {
            model: PointsCardModel,
        };

        enableSpinner(true);
        let createDefinition = await apiClient.createNewDefinition(data);
        enableSpinner(false);

        if (!createDefinition.status || createDefinition.status !== 1) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + createDefinition.message, timeOut: 5000 });
            await this.setState({
                showAreYouAgreeModal: false,
            });
            return;
        }
        showAlert({ type: "success", message: createDefinition.message, timeOut: 5000 });

        // listar las nuevas definiciones y cerrar modal
        enableSpinner(true);
        let definitions = await apiClient.GetDefinitions();
        enableSpinner(false);
        if (definitions.status !== 1) {
            showAlert({ type: "error", message: `${definitions.message}` });
        }
        PointsCardModel.Definitions = definitions.data || [];
        this.RefreshModel(PointsCardModel);
    }

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: false,
        });
    }

    activeShowAreYouAgreeModal_Point_Value = async () => {
        await this.setState({
            showAreYouAgreeModal_Point_Value: !this.state.showAreYouAgreeModal_Point_Value,
        });
        $('#areYouAgreeModal').modal('show');
    };

    CloseShowAreYouAgreeModal_Point_Value = async () => {
        await this.setState({
            showAreYouAgreeModal_Point_Value: false,
        });
    }

    Update_Point_Value = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;

        const data = {
            newValue: PointsCardModel.Point_Value,
        };

        enableSpinner(true);
        let responseUpdatePoint = await apiClient.updatePointValue(data);
        enableSpinner(false);

        if (!responseUpdatePoint.status || responseUpdatePoint.status !== 1) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + responseUpdatePoint.message, timeOut: 5000 });
            await this.setState({
                showAreYouAgreeModal_Point_Value: false,
            });
            return;
        }
        await this.setState({
            showAreYouAgreeModal_Point_Value: false,
        });
        showAlert({ type: "success", message: responseUpdatePoint.message, timeOut: 5000 });

        await this.GetAllConfiguration();
    }


    ShowPaymentInvoiceCredit = async () => {
        await this.GetAllConfiguration();
        await this.setState({
            showPaymentInvoiceCredit: !this.state.showPaymentInvoiceCredit,
        });

        $('#paymentInvoiceCreditPoinstCard').modal('show');
    };

    activeShowAreYouAgreeModal_InvoiceCredit = async () => {
        await this.setState({
            showAreYouAgreeModal_InvoiceCredit: !this.state.showAreYouAgreeModal_InvoiceCredit,
        });
        $('#areYouAgreeModal').modal('show');
    };

    CloseShowAreYouAgreeModal_InvoiceCredit = async () => {
        await this.setState({
            showAreYouAgreeModal_InvoiceCredit: false,
        });
    };

    change_InvoiceCredit = event => {
        const { PointsCardModel } = this.state;
        let value = event.nativeEvent.target.value
        PointsCardModel.InvoiceCredit = value;
        this.RefreshModel(PointsCardModel);
    };

    Update_InvoiceCredit = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;

        const data = {
            newValue: PointsCardModel.InvoiceCredit,
        };

        enableSpinner(true);
        let responseInvoiceCredit = await apiClient.updateInvoiceCredit(data);
        enableSpinner(false);

        if (!responseInvoiceCredit.status || responseInvoiceCredit.status !== 1) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + responseInvoiceCredit.message, timeOut: 5000 });
            await this.setState({
                showAreYouAgreeModal_InvoiceCredit: false,
            });
            return;
        }
        await this.setState({
            showAreYouAgreeModal_InvoiceCredit: false,
        });
        showAlert({ type: "success", message: responseInvoiceCredit.message, timeOut: 5000 });

        await this.GetAllConfiguration();
    };

    //#region VIGENCIA DE PUNTOS

    ShowLimitPoints = async () => {
        await this.GetAllConfiguration();
        if (this.state.showLimitPoints) return
        await this.setState({
            showLimitPoints: true,
        });

        $('#limitPoinstCard').modal('show');
    };

    // ShowAlertGenerateGeneralReport = async () => {
    //     await this.GetAllConfiguration();
    //     if (this.state.showAreYouAgreeModal_GenGenReport) return
    //     await this.setState({
    //         showAreYouAgreeModal_GenGenReport: true,
    //     });

    //     $('#areYouAgreeModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    // };

    // desactiveShowAreYouAgree_GenGenReport = async () => {
    //     await this.setState({
    //         showAreYouAgreeModal_GenGenReport: false,
    //     });
    // };

    GenerateGeneralReport = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        enableSpinner(true);
        const response = await apiClient.getAllCustomersPoints();

        if (response.status === 1) {
            let datafilter = [];

            for (let index = 0; index < response.data.length; index++) {
                const fila = response.data[index];

                let obj = {
                    Cliente: fila.cardCode || '',
                    Nombre: fila.CardName || '',
                    Fecha_Registro: moment(fila.registration_Date).utc().format("DD-MM-YYYY") || '',
                    Puntos_Acumulados: fila.totalPoints || '0',
                    Codigo_Monedero: fila.pointsCard || '',
                    Coreo: fila.U_FMB_Handel_Email || '',
                    Telefono: fila.U_FMB_Cellular || '',
                }
                datafilter.push(obj)
            }

            this.setState({ dataCsv: datafilter || [] })
            setTimeout(() => {
                this.csvLink.current.link.click();
            }, 500);
            enableSpinner(false);
        } else {
            showAlert({ type: 'error', message: response.message });
            enableSpinner(false);
        }
    }

    change_LastDate = event => {
        const { PointsCardModel } = this.state;
        let value = event.nativeEvent.target.value
        PointsCardModel.last_reset_date = value;
        this.RefreshModel(PointsCardModel);
    };

    activeShowAreYouAgreeModal_LastDate = async () => {
        await this.setState({
            showAreYouAgreeModal_LastDate: !this.state.showAreYouAgreeModal_LastDate,
        });
        $('#areYouAgreeModal').modal('show');
    };

    CloseShowAreYouAgreeModal_LastDate = async () => {
        await this.setState({
            showAreYouAgreeModal_LastDate: false,
        });
    };

    Update_LastDate = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;

        const data = {
            newValue: PointsCardModel.last_reset_date,
        };

        enableSpinner(true);
        let responseLastDate = await apiClient.updateLastDate(data);
        await apiClient.resetDate();
        enableSpinner(false);

        if (!responseLastDate.status || responseLastDate.status !== 1) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + responseLastDate.message, timeOut: 5000 });
            await this.setState({
                showAreYouAgreeModal_LastDate: false,
            });
            return;
        }
        await this.setState({
            showAreYouAgreeModal_LastDate: false,
        });
        showAlert({ type: "success", message: responseLastDate.message, timeOut: 5000 });

        await this.GetAllConfiguration();
    };

    //#endregion VIGENCIA DE PUNTOS

    // 
    // let numeroCliente = Math.floor(Math.random() * 900000000000) + 100000000000; // 12 dígitos
    // console.log('aaa',numeroCliente);
    // 

    //#endregion

    print = async (CardCode) => {
        const { enableSpinner, setPrintToDocumentsModal, showAlert } = this.props

        enableSpinner(true);
        const response = await apiClient.cardAccountStatus(CardCode);
        if (response.status === 1) {
            this.setState({ accountStatus: [response.data] });
            await setPrintToDocumentsModal(true);
            $('#printToDocumentsModal').modal('show');
        } else {
            showAlert({ type: 'error', message: response.message });
        }
        enableSpinner(false);
    }

    ResetDate = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        enableSpinner(true);
        let reset = await apiClient.resetDate();
        enableSpinner(false);

        if (!reset.status || reset.status !== 1) {
            showAlert({ type: "error", message: reset.message, timeOut: 5000 });
            await this.setState({
                showAreYouAgreeModal_Reset: false,
            });
            return;
        }
        await this.setState({
            showAreYouAgreeModal_Reset: false,
        });
        showAlert({ type: "success", message: reset.message, timeOut: 5000 });

        await this.GetAllConfiguration();
    }

    activeShowAreYouAgree_Reset = async () => {
        // VERSION 1
        // await this.setState({
        //     showAreYouAgreeModal_Reset: !this.state.showAreYouAgreeModal_Reset,
        // });
        // $('#areYouAgreeModal').modal('show');
        // VERSION 2
        if (this.state.showLimitPoints) return
        await this.setState({
            showLimitPoints: true,
        });
        $('#limitPoinstCard').modal('show');
    };
    closeLimitPointsCardModal = () => {
        $('#limitPoinstCard').modal('hide');
        this.setState({
            showLimitPoints: false,
        });
    }


    desactiveShowAreYouAgree_Reset = async () => {
        await this.setState({
            showAreYouAgreeModal_Reset: false,
        });
    };

    render() {
        const { enableSpinner, renderReducer: { renderToPrint } } = this.props;

        const {
            cliente,
            checkboxDataTables,
            partners,
            pageTotal,
            ModelCollect,
            folio,
            _user,
            sendMailModel,
            showPDFViewer,
            docsToPrint,
            EnableEditButton,

            printhide,



            dataCustomer,
            showNewCustomerModal,
            showConfigurationPointsCard,
            PointsCardModel,
            showAreYouAgreeModal,
            showAreYouAgreeModal_Point_Value,
            showAreYouAgreeModal_Update,
            accountStatus,
            actionCustomer,
            showAreYouAgreeModal_Reset,
            showConfigPointEquivalence,
            showPaymentInvoiceCredit,
            showAreYouAgreeModal_InvoiceCredit,
            showLimitPoints,
            showAreYouAgreeModal_LastDate,
            walletPermissions,
            // showAreYouAgreeModal_GenGenReport,
            dataCsv,
        } = this.state;

        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }

        let mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }
        let today = moment(new Date()).format('YYYYMMDD-hmm:ss');

        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'MONEDERO ELECTRÓNICO'} url1={'#'} />
                <CSVLink
                    data={dataCsv}
                    filename={`ReporteGeneralMonedero_${today}.csv`}
                    className="hidden"
                    ref={this.csvLink}
                    target="_blank"
                />
                <div style={{ marginLeft: "4rem" }}>
                    <div>

                        <div className="row m-1">
                            <h3 className="ml-4 mb-2 mt-3">Monedero Electrónico</h3>
                        </div>

                        <div className="row m-1">
                            <div className="col-xl-12 mb-4 mb-xl-0">
                                <div className="container-fluid mt-1">
                                    <div className="row">
                                        <div className="col-12" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
                                            <div className="row mb-4">
                                                <div className="col-12 col-md-6" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                    {/* <div className="col-3">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" id="basic-addon1"><strong>Factura</strong></span>
                                                        </div>
                                                        <input 
                                                            type="text" 
                                                            className="form-control"
                                                            placeholder="N° de documento"
                                                            id="numberSearch" 
                                                            // onKeyUp={()=>this.DoSearch("generalData","numberSearch")}
                                                            onChange={this.ChangeFolio}
                                                            value={folio ? folio : ''}
                                                        />
                                                    </div>
                                                </div> */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" id="basic-addon1" style={{ padding: '5px' }}><strong style={{ fontSize: '13px' }}>Cliente</strong></span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Código de cliente"
                                                            id="clientSearch"
                                                            style={{ padding: '5px', fontSize: '13px' }}
                                                            onChange={this.ChangeCliente}
                                                            value={cliente ? cliente : ''}
                                                            onKeyPress={(ev) => { if (ev.key === 'Enter') { this.CargarDatos(); } }}
                                                        />
                                                        <div className="input-group-append">
                                                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#afafaf', borderLeft: "none" }} onClick={() => this.CargarDatos()}>
                                                                <i className="fa fa-search" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 mb-2" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                    <button className="btn btn-active" onClick={() => this.openPartner()}
                                                        style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", marginRight: "1vh" }}>
                                                        <i className="fa fa-address-book-o"></i>
                                                    </button>
                                                </div>

                                                {false &&
                                                    <div className="col-12 col-md-6" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                        <div className="input-group mb-3">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Escribe el código de cliente o monedero electrónico"
                                                                id="Nro_Close"
                                                                onChange={this.ChangeFolio}
                                                                value={folio ? folio : ''}
                                                                onKeyPress={(ev) => { if (ev.key === 'Enter') { this.SearchPayment(); } }}
                                                            />
                                                            <div className="input-group-append">
                                                                <button type="button" className="input-group-text" /*data-toggle="modal" data-target="#paymentModal"*/ style={{ backgroundColor: 'transparent', color: '#afafaf', borderLeft: "none" }} onClick={() => this.SearchPayment()}>
                                                                    <i className="fa fa-search" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {/* CONFIGURACIÓN DE EQUIVALENCIA DE PUNTOS EN SOLES */}
                                                {/* disabled={newUser === 1 ? false : true} */}

                                                <div className="col-12 col-md-6" style={{ display: 'flex', alignItems: 'flex-start', textAlign: 'left' }}>
                                                    <div className="col-12" style={{ border: '2px solid rgb(0, 0, 0)', borderRadius: '10px', padding: '10px', marginBottom: '0px' }}>
                                                        <span style={{ fontSize: 13 }}>
                                                            1 punto equivale a <u><strong style={{ fontSize: 13 }}>{PointsCardModel.Point_Value ? PointsCardModel.Point_Value + ' SOL' : ''}</strong></u>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                                {walletPermissions && walletPermissions.filter(module => module.Active === 'Y').map((module, index) => {
                                                    return (
                                                        <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '200px', height: '50px', marginBottom: '5px', }}>
                                                            <button type="button" style={{ width: '200px', height: '50px', padding: '5px', textAlign: 'center', fontSize: '13px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => { this.setFunction(module.key) }}>
                                                                <span style={{ marginRight: '2px' }}><i className={module.key === 'GenGenReport' ? "fa fa-file-excel-o mr-sm-1" : "fas fa-cog"} style={{ fontSize: '14px', marginBottom: '5px' }} /></span>
                                                                <span style={{ wordWrap: 'break-word', whiteSpace: 'normal', fontSize: '13px' }}>
                                                                    {module.Name}
                                                                </span>
                                                            </button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <br />
                                            <div className='card scrollTableCollect'>
                                                <table className="table table-striped table-hover" id="generalData">
                                                    <thead className='sticky-headerPOS' style={{ backgroundColor: 'white', whiteSpace: 'nowrap' }}>
                                                        <tr>
                                                            {/* <th className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                    id="CheckAllCollet"
                                                                    onChange={(event) => checkbox.selectAll(event.target.checked)}
                                                                />
                                                            </th> */}
                                                            <th className=" text-center" scope="col">
                                                                Cliente
                                                            </th>
                                                            <th className=" text-center" scope="col">
                                                                Nombre
                                                            </th>
                                                            <th className=" text-center" scope="col">
                                                                Fecha registro
                                                            </th>
                                                            <th className=" text-center" scope="col">
                                                                Puntos acumulados
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                Código monedero
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                Correo
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                Teléfono
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                Detalle
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                Estado de Cuenta
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ whiteSpace: "nowrap" }}>
                                                        {!!dataCustomer && dataCustomer.map((customer, index) => {
                                                            return (
                                                                <tr key={index} >
                                                                    {/* <td className="text-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                            id="CheckAll"
                                                                            checked={!!checkbox.data.get(index)}
                                                                            onChange={() => checkbox.selectOne(index)}
                                                                        />
                                                                    </td> */}
                                                                    <td className="text-center">
                                                                        <strong>{customer.cardCode}</strong>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <strong>{customer.CardName || ''}</strong>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {customer.registration_Date ? moment(customer.registration_Date).utc().format('YYYY-MM-DD') : ''}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <strong>{customer?.totalPoints || 0}</strong>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <strong>{customer.pointsCard || ''}</strong>
                                                                    </td>
                                                                    <td className="text-center">{customer.U_FMB_Handel_Email || ''}</td>
                                                                    <td className="text-center">{customer.U_FMB_Cellular || ''}</td>
                                                                    <td className="text-center">
                                                                        <button className="btn btn-outline-info btn-active" onClick={() => this.ShowOneCustomer(customer.cardCode)}>
                                                                            Detalle
                                                                        </button>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <label className="btn float-left impr mr-sm-2" onClick={() => this.print(customer.cardCode)}><i className="fas fa-print"></i> Imprimir </label>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                </div>

                {partners.length > 0 &&
                    <PartnerCreateModal
                        data={partners}
                        type={'C'}
                        totalPage={pageTotal}
                        selectPartner={this.SelectPartner}
                        cleanData={() => this.setState({ partners: [] })}
                        refreshPartner={this.RefreshPartner}
                    />
                }

                {showNewCustomerModal &&
                    <NewCustomerModal
                        PointsCardModel={PointsCardModel}
                        cleanData={() => this.setState({ showNewCustomerModal: !this.state.showNewCustomerModal })}
                        change_CardName={this.change_CardName}
                        change_U_FMB_Handel_Email={this.change_U_FMB_Handel_Email}
                        change_U_FMB_Cellular={this.change_U_FMB_Cellular}
                        change_U_FMB_Handel_Pass={this.change_U_FMB_Handel_Pass}

                        sendNewCustomer={this.sendNewCustomer}
                        activeShowAreYouAgree_Update={this.activeShowAreYouAgree_Update}
                        showAreYouAgreeModal_Update={showAreYouAgreeModal_Update}
                        UpdateCustomer={this.UpdateCustomer}
                        desactiveShowAreYouAgree_Update={this.desactiveShowAreYouAgree_Update}
                        action={actionCustomer}
                    />
                }

                {showConfigurationPointsCard &&
                    <ConfigurationPointsCardModal
                        cleanData={() => this.setState({ showConfigurationPointsCard: !this.state.showConfigurationPointsCard })}
                        PointsCardModel={PointsCardModel}
                        GetAllConfiguration={this.GetAllConfiguration}
                        Add_Definitions={this.Add_Definitions}
                        Delete_Definitions={this.Delete_Definitions}
                        change_Name={this.change_Name}
                        change_MinAmount={this.change_MinAmount}
                        change_MaxAmount={this.change_MaxAmount}
                        change_PerAmount={this.change_PerAmount}
                        change_Points={this.change_Points}
                        change_RegularProfit={this.change_RegularProfit}
                        change_SpecialProfit={this.change_SpecialProfit}
                        change_PerSpecial={this.change_PerSpecial}
                        activeShowAreYouAgreeModal={this.activeShowAreYouAgreeModal}
                        showAreYouAgreeModal={showAreYouAgreeModal}
                        Add_newDefinition={this.Add_newDefinition}
                        CloseShowAreYouAgreeModal={this.CloseShowAreYouAgreeModal}
                        formatNumber={formatNumber}
                    />
                }

                {showConfigPointEquivalence &&
                    <PointEquivalencePointsCardModal
                        cleanData={() => this.setState({ showConfigPointEquivalence: !this.state.showConfigPointEquivalence })}
                        PointsCardModel={PointsCardModel}
                        change_Point_Value={this.change_Point_Value}
                        activeShowAreYouAgreeModal_Point_Value={this.activeShowAreYouAgreeModal_Point_Value}
                        showAreYouAgreeModal_Point_Value={showAreYouAgreeModal_Point_Value}
                        CloseShowAreYouAgreeModal_Point_Value={this.CloseShowAreYouAgreeModal_Point_Value}
                        GetAllConfiguration={this.GetAllConfiguration}
                        Update_Point_Value={this.Update_Point_Value}
                        change_RegularProfit={this.change_RegularProfit}
                        change_SpecialProfit={this.change_SpecialProfit}
                    />
                }

                {showPaymentInvoiceCredit &&
                    <PaymentInvoiceCreditPoinstCardModal
                        cleanData={() => this.setState({ showPaymentInvoiceCredit: !this.state.showPaymentInvoiceCredit })}
                        PointsCardModel={PointsCardModel}
                        change_InvoiceCredit={this.change_InvoiceCredit}
                        activeShowAreYouAgreeModal_InvoiceCredit={this.activeShowAreYouAgreeModal_InvoiceCredit}
                        showAreYouAgreeModal_InvoiceCredit={showAreYouAgreeModal_InvoiceCredit}
                        CloseShowAreYouAgreeModal_InvoiceCredit={this.CloseShowAreYouAgreeModal_InvoiceCredit}
                        GetAllConfiguration={this.GetAllConfiguration}
                        Update_InvoiceCredit={this.Update_InvoiceCredit}
                    />
                }

                {showLimitPoints &&
                    <LimitPoinstCardModal
                        cleanData={() => this.setState({ showLimitPoints: !this.state.showLimitPoints })}
                        PointsCardModel={PointsCardModel}
                        change_LastDate={this.change_LastDate}
                        activeShowAreYouAgreeModal_LastDate={this.activeShowAreYouAgreeModal_LastDate}
                        showAreYouAgreeModal_LastDate={showAreYouAgreeModal_LastDate}
                        CloseShowAreYouAgreeModal_LastDate={this.CloseShowAreYouAgreeModal_LastDate}
                        GetAllConfiguration={this.GetAllConfiguration}
                        Update_LastDate={this.Update_LastDate}
                        updatePointsCardModal={(newValue) => this.setState({ showLimitPoints: newValue })}
                    />
                }

                {showPDFViewer && (
                    <PdfViewer
                        DocsToPrint={docsToPrint}
                        TypeDoc={'ORCT'}
                        EnableEditButton={EnableEditButton}
                        Editable={false}
                        ChangeEditableMode={() => { }}
                        EditParam1={false}
                        CreateDocument={this.CreateDocument}
                        OpenMailModal={this.OpenSendMailModal}
                        ItsFirme={true}
                        user={_user}
                        Counter={true}
                        MailTools={mailTools}
                        printhide={printhide}
                    />
                )}

                {renderToPrint &&
                    <PrintToDocumentsModal
                        data={accountStatus}
                        view={'PointsCard'}
                        _user={_user}
                    />
                }

                {showAreYouAgreeModal_Reset &&
                    <AreYouAgreeModal
                        mensaje={'Es necesario reiniciar el año'}
                        accept={this.ResetDate}
                        cancel={this.desactiveShowAreYouAgree_Reset}
                    />
                }

                {/* {showAreYouAgreeModal_GenGenReport &&
                    <AreYouAgreeModal
                        mensaje={'¿Estas seguro que deseas generar el reporte general?'}
                        accept={this.GenerateGeneralReport}
                        cancel={this.desactiveShowAreYouAgree_GenGenReport}
                    />
                } */}
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        renderReducer: store.RenderReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setPrintToDocumentsModal: value => dispatch({ type: DISPATCH_ID.RENDER_PRINT_TO_DOCUMENTS_MODAL, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PointsCardView);
